import { ReactNode } from "react";

import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

interface ILegalNoticeSubsectionProps {
  title: string;
  number?: string;
  children: ReactNode;
}

export const LegalNoticeSubsection = ({
  title,
  number,
  children,
}: ILegalNoticeSubsectionProps) => {
  return (
    <Box display="flex" flexDirection="column" gap={2}>
      <Typography
        variant="body2"
        component="h4"
        fontSize="inherit"
        lineHeight="inherit"
        fontWeight={700}
        sx={{ fontVariantNumeric: "tabular-nums" }}
      >
        {number ? `${number} ` : ""}
        {title}
      </Typography>
      {children}
    </Box>
  );
};

(
  LegalNoticeSubsection as { __isLegalNoticeSubsection?: boolean }
).__isLegalNoticeSubsection = true;
